<template>
  <LoadingWrapper :state="loadingState">
    <FullScreenLayoutContent :full-width="true">
      <template #header>
        <div class="flex h-16 items-center justify-between px-3 md:h-20 md:px-4">
          <a href="https://menon.group" target="_blank">
            <MenonLogo class="h-10 w-10" />
          </a>
          <div v-if="state == 'feedback'" class="flex flex-row items-center">
            <span class="text-title-medium ml-2">
              <span> {{ $t('common.to') }}: {{ data.receiverName }} </span>
            </span>
          </div>
        </div>
      </template>
      <template #footer>
        <div
          v-if="state == 'start'"
          class="flex h-16 w-full items-center justify-end px-3 md:h-20 md:px-4"
        >
          <a
            href="https://menon.group"
            target="_blank"
            class="text-body-small text-on-surface-variant hover:underline"
          >
            Powered by Menon - Macht gutes Feedback einfach
          </a>
        </div>
      </template>
      <div class="w-full">
        <PublicThxScreen v-if="state == 'saved'" />
        <PublicStartScreen
          v-if="state == 'start'"
          :receiver-name="data.receiverName"
          :number-of-questions="
            data.questionGroups.flatMap((questionGroup) => questionGroup.questions).length
          "
          :time-estimate="data.timeEstimate"
          :message="data.message"
          :organization-name="data.organizationName"
          :title="data.title"
          :perspective="data.perspective"
          @skip-start-screen="skipStartScreen"
        />
        <PublicFinishFeedbackScreen
          v-if="state == 'finished'"
          :question-groups="data.questionGroups"
          :receiver-name="data.receiverName"
        />
        <template v-if="state == 'feedback'">
          <SingleQuestionsView :question-groups="data.questionGroups" />
        </template>
      </div>
    </FullScreenLayoutContent>
  </LoadingWrapper>
</template>

<script setup lang="ts">
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import { useRoute } from 'vue-router'
  import { ref } from 'vue'
  import SingleQuestionsView from '../components/single-questions-view/SingleQuestionsView.vue'
  import FullScreenLayoutContent from '@/core/components/layouts/FullScreenLayoutContent.vue'
  import { usePublicGiveStructuredFeedback } from '../composables/usePublicGiveStructuredFeedback'
  import PublicFinishFeedbackScreen from '../components/finish-screen/PublicFinishFeedbackScreen.vue'
  import PublicStartScreen from '../components/public-start-screen/PublicStartScreen.vue'
  import MenonLogo from '@/core/components/MenonLogo.vue'
  import PublicThxScreen from '../components/thx-screen/PublicThxScreen.vue'

  const route = useRoute()

  const token = ref(route.params.token as string)

  const { data, loadingState, state, skipStartScreen } = usePublicGiveStructuredFeedback(
    token.value,
  )
</script>
